import { useState } from 'react'

const useFilterModal = (onFormat, allData = [], onAdditionalFilter, asset) => {
    const [filteredData, setFilteredData] = useState([])

    const onFilter = filters => {
        if (onAdditionalFilter) {
            onAdditionalFilter(filters)
        }
        var resultList = [...allData]
        var hasOneChecked = false
        filters?.forEach(filterG => {
            var matchesResults = []
            var thisFiltersHasResults = false
            filterG?.filters?.forEach(filter => {
                if (filter?.checked) {
                    thisFiltersHasResults = true
                    hasOneChecked = true
                    matchesResults = [
                        ...matchesResults,
                        ...resultList?.filter(r => {
                            const isLocation = filter?.isLocation
                            if (isLocation) {
                                return r[filterG?.field] == filter?.shiptoId
                            } else {
                                const valueToCompare =
                                    typeof r[filterG?.field] === 'boolean'
                                        ? true
                                        : filter?.filterName
                                return r[filterG?.field] === valueToCompare
                            }
                        }),
                    ]
                }
            })
            if (thisFiltersHasResults) {
                resultList = [...matchesResults]
            } else [(resultList = [...resultList])]
        })

        if (hasOneChecked) {
            setFilteredData(onFormat(resultList, asset))
        } else {
            setFilteredData(onFormat(allData, asset))
        }
    }

    return {
        onFilter,
        filteredData,
        setFilteredData,
    }
}

export default useFilterModal
